import { cva } from '@/styled-system/css';

export const comboboxOptionMediaRecipe = cva({
  base: {
    'gridArea': 'media',

    '& > [data-c11n-component="Icon"]': {
      color: { base: 'icon.action.neutral.default' },
      width: 'icon.md',
      height: 'icon.md',
    },
  },
  variants: {
    appearance: {
      checkbox: {
        _before: {
          width: 'Checkbox.box',
          height: 'Checkbox.box',
          backgroundColor: 'Checkbox.bg.default',
          borderWidth: 'thick',
          borderColor: 'Checkbox.border.default',
          borderRadius: 'Checkbox.box',
        },
      },
      radio: {
        _before: {
          width: 'Radio.ring.width',
          height: 'Radio.ring.height',
          borderWidth: 'Radio.ring.default',
          borderColor: 'Radio.border.default',
          borderRadius: 'Radio',
        },
      },
    },
    disabled: {
      true: {},
      false: {
        '& > [data-c11n-component="Icon"]': {
          color: {
            _groupHover: 'icon.action.neutral.hover',
            _groupActive: 'icon.action.neutral.pressed',
          },
        },
      },
    },
    selected: {
      true: {
        '& > [data-c11n-component="Icon"]': {
          color: { base: 'icon.action.neutral.default' },
        },
      },
      false: {},
    },
  },
  compoundVariants: [
    {
      appearance: ['checkbox', 'radio'],
      css: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'relative',
        width: 'icon.md',
        height: 'icon.md',
        _before: {
          content: '""',
          cursor: 'pointer',
          display: 'inline-flex',
          borderStyle: 'solid',
          transition: {
            _motionReduce: 'none',
            _motionSafe: '{border-color 0.15s ease-in-out, background-color 0.15s ease-in-out}',
          },
        },
      },
    },
    {
      appearance: 'checkbox',
      disabled: false,
      selected: false,
      css: {
        _groupHover: {
          _before: {
            backgroundColor: 'Checkbox.bg.hover',
            borderColor: 'Checkbox.border.hover',
          },
        },
        _groupActive: {
          _before: {
            backgroundColor: 'Checkbox.bg.pressed',
            borderColor: 'Checkbox.border.pressed',
          },
        },
      },
    },
    {
      appearance: 'radio',
      disabled: false,
      selected: false,
      css: {
        _groupHover: {
          _before: {
            borderColor: 'Radio.border.hover',
          },
        },
        _groupActive: {
          _before: {
            borderColor: 'Radio.border.pressed',
          },
        },
      },
    },
    {
      appearance: ['checkbox', 'radio'],
      disabled: true,
      css: {
        _before: {
          opacity: 'disabled',
          cursor: 'default',
        },
      },
    },
    {
      appearance: 'checkbox',
      selected: true,
      css: {
        _before: {
          backgroundPosition: '0',
          backgroundSize: '100%',
          backgroundRepeat: 'no-repeat',
          backgroundImage: `url("data:image/svg+xml;utf8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20aria-hidden%3D%22true%22%20viewBox%3D%220%200%2032%2032%22%3E%3Cpath%20d%3D%22M29.41%206.57a2%202%200%200%200-2.83%200L11.36%2021.32l-5.95-5.77a2%202%200%200%200-2.83%200%201.9%201.9%200%200%200%200%202.74L10%2025.43a2%202%200%200%200%202.83%200L29.41%209.31a1.9%201.9%200%200%200%200-2.74z%22%20fill%3D%22%23FFF%22%2F%3E%3C%2Fsvg%3E")`,
          backgroundColor: 'bg.action.hero.selected.default',
          borderColor: 'border.action.hero.selected.default',
        },
        // Doesn't seem to like the backgroundImage in the dark variant, so we're using a separate rule
        _dark: {
          _before: {
            backgroundImage: `url("data:image/svg+xml;utf8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20aria-hidden%3D%22true%22%20viewBox%3D%220%200%2032%2032%22%3E%3Cpath%20d%3D%22M29.41%206.57a2%202%200%200%200-2.83%200L11.36%2021.32l-5.95-5.77a2%202%200%200%200-2.83%200%201.9%201.9%200%200%200%200%202.74L10%2025.43a2%202%200%200%200%202.83%200L29.41%209.31a1.9%201.9%200%200%200%200-2.74z%22%20fill%3D%22%23000%22%2F%3E%3C%2Fsvg%3E")`,
          },
        },
        _groupHover: {
          _before: {
            backgroundColor: 'bg.action.hero.selected.hover',
            borderColor: 'border.action.hero.selected.hover',
          },
        },
        _groupActive: {
          _before: {
            backgroundColor: 'bg.action.hero.selected.pressed',
            borderColor: 'border.action.hero.selected.pressed',
          },
        },
      },
    },
    {
      appearance: 'radio',
      selected: true,
      css: {
        _before: {
          borderColor: 'border.action.hero.selected.default',
          borderWidth: 'Radio.ring.selected',
        },
        _groupHover: {
          _before: {
            borderColor: 'border.action.hero.selected.hover',
          },
        },
        _groupActive: {
          _before: {
            borderColor: 'border.action.hero.selected.pressed',
          },
        },
      },
    },
  ],
});
